module.exports = __webpack_public_path__ + "static/img/newsnn.c57e9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsnn.jpg
// module id = I3m5
// module chunks = 45